(() => {

  const setup = (root) => {

    if (root.dataset.mmReady || !root.querySelector('[data-mm-product-data]')) return;

    root.dataset.mmReady = 'true';

    const data = JSON.parse(root.querySelector('[data-mm-product-data]').textContent);

    const form = root.querySelector('.mm-product-form');

    const variantSelect = form.querySelector('[data-mm-variant]');

    const planSelect = form.querySelector('[data-mm-plan]');

    const quantity = form.querySelector('[data-mm-quantity-input]');

    const status = root.querySelector('[data-mm-status]');

    const submit = root.querySelector('[data-mm-add]');

    const sticky = root.querySelector('[data-mm-sticky]');

    const stickySubmit = root.querySelector('[data-mm-sticky-add]');

    let busy = false;

    let lastVariantId = variantSelect.value;

    const current = () => data.variants.find((variant) => String(variant.id) === variantSelect.value);

    const panels = [...root.querySelectorAll('[data-mm-panel]')];

    const thumbs = [...root.querySelectorAll('[data-mm-thumb]')];

    const selectMedia = (id, focus = false) => {

      const panel = panels.find((item) => item.dataset.mmPanel === String(id));

      if (!panel) return;

      panels.forEach((item) => {

        const wasVisible = !item.hidden;

        item.hidden = item !== panel;

        if (item !== panel) {

          item.querySelectorAll('video').forEach((video) => video.pause());

          if (wasVisible) item.querySelectorAll('iframe').forEach((frame) => { frame.src = frame.src; });

        }

      });

      thumbs.forEach((thumb) => {

        const selected = thumb.dataset.mmThumb === String(id);

        thumb.setAttribute('aria-selected', String(selected));

        thumb.tabIndex = selected ? 0 : -1;

        if (selected && focus) thumb.focus({ preventScroll: true });

      });

    };

    if (thumbs.length > 1) root.querySelector('[data-mm-thumbnails]').hidden = false;

    thumbs.forEach((thumb, index) => {

      thumb.addEventListener('click', () => selectMedia(thumb.dataset.mmThumb));

      thumb.addEventListener('keydown', (event) => {

        let next = index;

        if (event.key === 'ArrowRight') next = (index + 1) % thumbs.length;

        else if (event.key === 'ArrowLeft') next = (index - 1 + thumbs.length) % thumbs.length;

        else if (event.key === 'Home') next = 0;

        else if (event.key === 'End') next = thumbs.length - 1;

        else return;

        event.preventDefault();

        selectMedia(thumbs[next].dataset.mmThumb, true);

      });

    });

    const dialog = root.querySelector('[data-mm-dialog]');

    if (dialog && typeof dialog.showModal === 'function') {

      root.querySelectorAll('[data-mm-zoom]').forEach((button) => {

        button.hidden = false;

        button.addEventListener('click', () => {

          const image = dialog.querySelector('[data-mm-zoom-image]');

          image.src = button.dataset.image;

          image.alt = button.dataset.alt;

          dialog.showModal();

        });

      });

      dialog.querySelector('[data-mm-close]').addEventListener('click', () => dialog.close());

      dialog.addEventListener('click', (event) => {

        if (event.target !== dialog) return;

        const box = dialog.getBoundingClientRect();

        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();

      });

    }

    const update = (variantChanged = false) => {

      const variant = current();

      if (!variant) return;

      if (planSelect && variantChanged) {

        const previous = planSelect.value;

        planSelect.replaceChildren();

        if (!data.requiresPlan) planSelect.add(new Option(data.strings.oneTime, ''));

        variant.plans.forEach((plan) => planSelect.add(new Option(`${plan.name} - ${plan.priceText}`, plan.id)));

        if ([...planSelect.options].some((option) => option.value === previous)) planSelect.value = previous;

        planSelect.disabled = !variant.plans.length;

        root.querySelector('[data-mm-plans-wrapper]').hidden = !variant.plans.length && !data.requiresPlan;

      }

      const allocation = planSelect ? variant.plans.find((plan) => plan.id === planSelect.value) : null;

      const price = allocation || variant;

      root.querySelector('[data-mm-price]').textContent = price.priceText;

      root.querySelector('[data-mm-sticky-price]').textContent = price.priceText;

      const compare = root.querySelector('[data-mm-compare]');

      compare.hidden = !(price.compare > price.price);

      compare.textContent = price.compareText;

      const unit = root.querySelector('[data-mm-unit]');

      unit.hidden = !variant.unitText;

      unit.textContent = variant.unitText;

      const terms = root.querySelector('[data-mm-plan-terms]');

      if (terms) terms.textContent = allocation ? allocation.terms : '';

      const available = variant.available && (!data.requiresPlan || Boolean(allocation));

      submit.disabled = busy || !available;

      stickySubmit.disabled = busy || !available;

      const label = busy ? data.strings.adding : !variant.available ? data.strings.soldOut : !available ? data.strings.unavailable : data.strings.add;

      root.querySelector('[data-mm-add-label]').textContent = label;

      root.querySelector('[data-mm-sticky-label]').textContent = label;

      if (variantChanged) {

        quantity.min = variant.minimum;

        quantity.step = variant.increment;

        if (variant.maximum) quantity.max = variant.maximum;

        else quantity.removeAttribute('max');

        let nextQuantity = Math.max(variant.minimum, Number(quantity.value) || variant.minimum);

        nextQuantity = variant.minimum + Math.ceil((nextQuantity - variant.minimum) / variant.increment) * variant.increment;

        if (variant.maximum) nextQuantity = Math.min(nextQuantity, variant.maximum);

        quantity.value = nextQuantity;

        selectMedia(variant.mediaId);

        const url = new URL(window.location.href);

        url.searchParams.set('variant', variant.id);

        if (allocation) url.searchParams.set('selling_plan', allocation.id);

        else url.searchParams.delete('selling_plan');

        window.history.replaceState({}, '', url);

        status.textContent = '';

        root.querySelector('[data-mm-view-cart]').hidden = true;

      }

    };

    variantSelect.addEventListener('change', () => {

      const changed = lastVariantId !== variantSelect.value;

      lastVariantId = variantSelect.value;

      update(changed);

    });

    if (planSelect) planSelect.addEventListener('change', () => update());

    root.querySelectorAll('[data-mm-quantity]').forEach((button) => {

      button.hidden = false;

      button.addEventListener('click', () => {

        const increment = Number(quantity.step) || 1;

        const minimum = Number(quantity.min) || 1;

        const maximum = quantity.max ? Number(quantity.max) : Infinity;

        quantity.value = Math.max(minimum, Math.min(maximum, Number(quantity.value) + Number(button.dataset.mmQuantity) * increment));

        quantity.dispatchEvent(new Event('change', { bubbles: true }));

      });

    });

    if ('IntersectionObserver' in window && sticky) {

      const observer = new IntersectionObserver((entries) => {

        sticky.hidden = entries[0].isIntersecting;

      }, { threshold: 0.05 });

      observer.observe(form);

      root.mmProductObserver = observer;

    }

    form.addEventListener('submit', async (event) => {

      event.preventDefault();

      if (busy || !form.reportValidity()) return;

      const variant = current();

      if (!variant || !variant.available) return;

      if (data.requiresPlan && (!planSelect || !variant.plans.some((plan) => plan.id === planSelect.value))) {

        status.textContent = data.strings.choosePlan;

        status.focus();

        return;

      }

      busy = true;

      form.setAttribute('aria-busy', 'true');

      root.classList.add('mm-product-is-loading');

      status.textContent = '';

      root.querySelector('[data-mm-view-cart]').hidden = true;

      update();

      try {

        const body = new FormData(form);

        if (!body.get('selling_plan')) body.delete('selling_plan');
        window.MMExternalCheckout?.prepareSourceBody(body);

        const response = await fetch(`${data.root}cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json' } });

        const result = await response.json();

        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : data.strings.error);

        status.textContent = data.strings.added;

        root.querySelector('[data-mm-view-cart]').hidden = false;

        window.dispatchEvent(new CustomEvent('mm:cart-added', { detail: { item: result } }));

        try {

          const cartResponse = await fetch(`${data.root}cart.js`, { headers: { Accept: 'application/json' } });

          if (cartResponse.ok) window.dispatchEvent(new CustomEvent('mm:cart-updated', { detail: { cart: await cartResponse.json() } }));

        } catch (_) {}

      } catch (error) {

        status.textContent = error.message || data.strings.error;

        status.focus({ preventScroll: true });

      } finally {

        busy = false;

        form.removeAttribute('aria-busy');

        root.classList.remove('mm-product-is-loading');

        update();

      }

    });

    update();

  };

  const initialize = (context = document) => {

    if (context.matches?.('[data-mm-product]')) setup(context);

    context.querySelectorAll('[data-mm-product]').forEach(setup);

  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());

  else initialize();

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  document.addEventListener('shopify:section:unload', (event) => {

    event.target.querySelectorAll('[data-mm-product]').forEach((root) => root.mmProductObserver?.disconnect());

  });

})();

